import { z } from 'zod'
import { email, requiredString } from '../../primitives/string'
import { MESSAGES } from '../../utils/messages'

/**
 * Agencia (sucursal de una empresa) — fuente única de verdad para la
 * validación del API (nestjs-zod `createZodDto`) y del formulario web
 * (RHF + zodResolver).
 *
 * `code` es único POR EMPRESA (la misma sucursal "01" puede existir en dos
 * empresas distintas). Reglas de dominio en el service: una sola `default`
 * por empresa (marcar una desmarca la anterior y la fuerza activa), la
 * default no se desactiva, y no se eliminan bloqueadas ni la default.
 * `direction` es la dirección física (nombre de wire legacy — se mantiene
 * hasta un pase de contrato v2).
 */

// ObjectId de Mongo serializado (24 hex): el wire actual identifica la empresa
// por ObjectId; no cambiar hasta contrato v2.
const objectIdString = z
  .string({ required_error: MESSAGES.REQUIRED, invalid_type_error: MESSAGES.REQUIRED })
  .regex(/^[a-f0-9]{24}$/i, 'Identificador inválido')

const AgencyInputBaseSchema = z.object({
  name: requiredString()
    .transform((value) => value.trim())
    .pipe(requiredString()),
  code: requiredString()
    .transform((value) => value.trim())
    .pipe(requiredString()),
  direction: requiredString(),
  email: requiredString().pipe(email()),
  phone: requiredString(),
  company: objectIdString,
  default: z.boolean().optional(),
  active: z.boolean().optional()
})

export const CreateAgencyInputSchema = AgencyInputBaseSchema

export const UpdateAgencyInputSchema = AgencyInputBaseSchema.partial()

export type CreateAgencyInput = z.infer<typeof CreateAgencyInputSchema>
export type UpdateAgencyInput = z.infer<typeof UpdateAgencyInputSchema>
